"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportedLocales = exports.localesMapping = exports.localeNamesMapping = exports.getIsLocaleSupported = exports.getISOLocale = exports.getFormattedRCLocale = exports.getAdaptedLocale = void 0;
const RCLocalesMapping = {
  'en-CA': 'en-US',
  'en-GB': 'en-US',
  'nb-NO': 'no-NO',
  'nn-NO': 'no-NO'
};
const ISOLocalesMapping = {
  da: 'da-DK',
  no: 'no-NO',
  en: 'en-US',
  fi: 'fi-FI',
  hu: 'hu-HU',
  it: 'it-IT',
  et: 'et-EE',
  ru: 'ru-RU'
};
const BCP47LocalesMapping = {
  'en-AU': 'en-US',
  'en-CA': 'en-US',
  'en-GB': 'en-US',
  'en-IE': 'en-US',
  'en-IN': 'en-US',
  'en-NZ': 'en-US',
  'en-ZA': 'en-US',
  'it-CH': 'it-IT'
};
const localesMapping = exports.localesMapping = {
  ...RCLocalesMapping,
  ...ISOLocalesMapping,
  ...BCP47LocalesMapping
};
const localeNamesMapping = exports.localeNamesMapping = {
  'da-DK': 'Danish (Dansk)',
  'no-NO': 'Norwegian (Norsk)',
  'en-US': 'English',
  'fi-FI': 'Finnish (Suomi)',
  'hu-HU': 'Hungarian (Magyar)',
  'it-IT': 'Italian (Italiano)',
  'et-EE': 'Estonian (Eesti)',
  'ru-RU': 'Russian (Русский)'
};
const supportedLocales = exports.supportedLocales = ['da-DK', 'no-NO', 'en-US', 'fi-FI', 'hu-HU', 'it-IT', 'et-EE', 'ru-RU'];
const getIsLocaleSupported = locale => {
  return supportedLocales.includes(locale);
};
exports.getIsLocaleSupported = getIsLocaleSupported;
const getFormattedIOSLocale = locale => {
  const parts = locale.split('-');
  if (parts.length > 1) {
    parts[1] = parts[1].toUpperCase();
  }
  return parts.join('-');
};
const getAdaptedLocale = locale => {
  const formattedLocale = getFormattedIOSLocale(locale);
  return localesMapping[formattedLocale] || formattedLocale;
};
exports.getAdaptedLocale = getAdaptedLocale;
const getFormattedRCLocale = locale => {
  const formattedLocale = String(locale).replace('_', '-');
  return getAdaptedLocale(formattedLocale);
};
exports.getFormattedRCLocale = getFormattedRCLocale;
const getISOLocale = bcpLocale => {
  return Object.entries(ISOLocalesMapping).find(_ref => {
    let [, bcpCode] = _ref;
    return bcpCode === bcpLocale;
  })?.[0];
};
exports.getISOLocale = getISOLocale;